import request from '/src/api/request.js'
/** -------------------------------------------- 假期规则 -------------------------------------------- */
/**
 * 假期规则设置分页
 */
export function selectHolidayRulePage(query) {
    return request({
        url: 'sys/holidayRules/GetHolidayRulesByPage',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}

/**
 * 新增假期规则
 */
export function createdHolidayRule(item) {
    return request({
        url: 'sys/holidayRules/insertHolidayRules',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}
/**
 * 更新假期规则
 */
export function updateHolidayRule(item) {
    return request({
        url: 'sys/holidayRules/updateHolidayRules',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}

/**
 * 删除假期规则
 */
export function deleteHolidayRule(HolidayRulesId) {
    return request({
        url: 'sys/holidayRules/deleteHolidayRules',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: HolidayRulesId,
    })
}

/**
 * 假期规则-获取限制余额的假期规则（假期余额界面的批量更新在使用）
 */
export function selectHolidayRules() {
    return request({
        url: 'sys/holidayRules/GetLimitBalanceHolidayRules',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
    })
}



/** -------------------------------------------- 假期余额 -------------------------------------------- */
/**
 * 假期余额分页
 */
export function selectHolidayRemainingPage(query) {
    return request({
        url: 'sys/holidayBalance/GetHolidayBalancePage',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}
/**
 * 更新用户的入职时间、首次工作时间
 */

export function updateUserInfo(item) {
    return request({
        url: 'sys/holidayBalance/UpdateWorkInformation',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}
/**
 * 假期余额 - 修改假期余额
 */
export function updateHolidayRemaining(item) {
    return request({
        url: 'sys/holidayBalance/UpdateHolidayBalance',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}

/**
 * 假期余额 - 修改假期、使用假期记录
 */
export function selectHolidayRemainingStream(item) {
    return request({
        url: 'sys/holidayBalance/GetHolidayBalanceStream',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}

/**
 * 假期余额 - 导出
 */
export function exportHolidayRemaining(query) {
    return request({
        url: 'sys/holidayBalance/exportHolidayBalance',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}

/**
 *  假期余额 - 导入
 */
export function importResetHolidayBalance(file) {
    return request({
        url: 'sys/holidayBalance/importResetHolidayBalance',
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        method: 'POST',
        data: file,
    })
}